import React from 'react'
import cn from 'classnames'

import './toggle-switch.styl'

type Props = {
  text?: string
  checked?: boolean
  onChange(arg0: React.SyntheticEvent<HTMLInputElement>): void
  className?: string
  disabled?: boolean
}

const ToggleSwitch = ({
  text,
  checked,
  onChange,
  className,
  disabled,
}: Props): JSX.Element => (
  <label className={cn('toggle-switch', className)}>
    <input
      className="toggle-switch__input"
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    <div className={cn('toggle-switch__toggle', { disabled })} />
    {text}
  </label>
)

export default ToggleSwitch
